import React, { useContext } from "react";
import { CommonDropdown } from "./CommonDropdown";
import { string, func } from "prop-types";
import { useTextDomainContext } from "@/app/providers";

export const ConsumptionOrCo2Dropdown = (props: any) => {
  const { TextDomainContext } = useTextDomainContext();
  const { gettext } = useContext(TextDomainContext);
  const options = [
    {
      value: "consumption",
      label: gettext("Energy"),
    },
    {
      value: "climate",
      label: gettext("Climate"),
    },
  ];
  const propsDefault = {
    componentLabel: gettext("Report"),
  };

  // Use props directly with fallback instead of state
  const componentLabel = props.componentLabel || propsDefault.componentLabel;

  return (
    <CommonDropdown
      options={
        options as unknown as import("@/types/Dropdown.types").DropdownOption[]
      }
      componentLabel={componentLabel}
      showAll={false}
      defaultValue={props.defaultValue}
      onChange={props.onChange}
    />
  );
};

ConsumptionOrCo2Dropdown.propTypes = {
  componentLabel: string,
  defaultValue: string,
  onChange: func,
};
